import React, { useState } from 'react';

const LOGO_URL = 'https://i.ibb.co/YFHLQ248/blanda-logo.png';

// SVG Icons
const IconLocation = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
    <circle cx="12" cy="9" r="2.5"/>
  </svg>
);

const IconPhone = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8 19.79 19.79 0 01.01 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
  </svg>
);

const IconEmail = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);

const IconFacebook = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
  </svg>
);

const IconInstagram = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
    <circle cx="12" cy="12" r="4"/>
    <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor"/>
  </svg>
);

const icons = [
  {
    id: 'location',
    Icon: IconLocation,
    tooltip: <>Θα μας βρείτε στη διεύθυνση:<br /><strong>Θεμιστοκλέους 64, 174 55 Άλιμος, Αθήνα</strong></>,
    href: null,
  },
  {
    id: 'phone',
    Icon: IconPhone,
    tooltip: <>Τηλέφωνα επικοινωνίας:<br /><strong>210 9881816<br />6945 197000<br />6976 447820</strong></>,
    href: null,
  },
  {
    id: 'email',
    Icon: IconEmail,
    tooltip: <>Ηλεκτρονική διεύθυνση:<br /><strong>blanda.amke@gmail.com</strong></>,
    href: 'mailto:blanda.amke@gmail.com',
  },
  {
    id: 'facebook',
    Icon: IconFacebook,
    tooltip: <strong>Facebook page</strong>,
    href: 'https://www.facebook.com/blandaamke',
  },
  {
    id: 'instagram',
    Icon: IconInstagram,
    tooltip: <strong>Instagram page</strong>,
    href: 'https://www.instagram.com/blanda.gr/',
  },
];

function IconButton({ item }) {
  const [hovered, setHovered] = useState(false);

  const inner = (
    <div
      style={{ position: 'relative', display: 'inline-flex' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Circle */}
      <div style={{
        width: '44px',
        height: '44px',
        borderRadius: '50%',
        border: `1px solid ${hovered ? 'var(--accent)' : 'rgba(255,255,255,0.25)'}`,
        background: hovered ? 'rgba(200,169,110,0.15)' : 'rgba(255,255,255,0.05)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: hovered ? 'var(--accent)' : 'rgba(255,255,255,0.6)',
        transition: 'all 0.25s ease',
        cursor: 'pointer',
      }}>
        <item.Icon />
      </div>

      {/* Tooltip */}
      <div style={{
        position: 'absolute',
        bottom: 'calc(100% + 12px)',
        left: '50%',
        transform: 'translateX(-50%)',
        background: 'rgba(26,23,20,0.97)',
        border: '1px solid rgba(200,169,110,0.3)',
        color: 'var(--light-gray)',
        padding: '12px 16px',
        borderRadius: '2px',
        fontSize: '0.72rem',
        lineHeight: 1.7,
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
        opacity: hovered ? 1 : 0,
        transform: hovered
          ? 'translateX(-50%) translateY(0)'
          : 'translateX(-50%) translateY(6px)',
        transition: 'opacity 0.2s ease, transform 0.2s ease',
        zIndex: 10,
        letterSpacing: '0.03em',
      }}>
        {item.tooltip}
        {/* Arrow */}
        <div style={{
          position: 'absolute',
          top: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: '6px solid transparent',
          borderRight: '6px solid transparent',
          borderTop: '6px solid rgba(200,169,110,0.3)',
        }} />
      </div>
    </div>
  );

  if (item.href) {
    return (
      <a href={item.href} target={item.href.startsWith('http') ? '_blank' : undefined}
        rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
        {inner}
      </a>
    );
  }
  return inner;
}

export default function Footer() {
  return (
    <footer style={{ background: 'var(--black)', color: 'var(--mid-gray)', padding: '56px 64px 40px' }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        gap: '40px',
        marginBottom: '48px',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
        paddingBottom: '48px',
      }}>
        <div>
          <img src={LOGO_URL} alt="BLANDA" style={{ height: '80px', width: 'auto', marginBottom: '16px' }} />
          <p style={{ fontSize: '0.7rem', letterSpacing: '0.1em', lineHeight: 1.8, maxWidth: '280px' }}>
            Αστική Μη Κερδοσκοπική Εταιρεία Πολιτισμού
          </p>
        </div>

        <div style={{ display: 'flex', gap: '64px', flexWrap: 'wrap' }}>
          <div>
            <h4 style={{ fontSize: '0.6rem', letterSpacing: '0.16em', textTransform: 'uppercase', color: 'var(--accent)', marginBottom: '16px' }}>
              Πλοήγηση
            </h4>
            {['Αρχική', 'Επικοινωνία'].map(item => (
            // {['Αρχική', 'Η Ομάδα', 'Παραστάσεις', 'Εργαστήρια', 'Box Office', 'Επικοινωνία'].map(item => (
              <p key={item} style={{ fontSize: '0.75rem', marginBottom: '10px', letterSpacing: '0.06em' }}>{item}</p>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '20px',
      }}>
        <p style={{ fontSize: '0.65rem', letterSpacing: '0.08em' }}>
          © {new Date().getFullYear()} BLANDA.
        </p>

        {/* Icon row */}
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          {icons.map(item => (
            <IconButton key={item.id} item={item} />
          ))}
        </div>
      </div>
    </footer>
  );
}
